import { useEffect, useState } from "react";
import { api, brl } from "@/lib/api";
import { TopBar } from "@/components/Shell";

export default function CourierEarnings() {
  const [e, setE] = useState(null);
  useEffect(() => { api.get("/courier/earnings").then(({ data }) => setE(data)).catch(() => {}); }, []);
  if (!e) return <div className="p-6 text-sm text-gray-500">Carregando ganhos…</div>;

  return (
    <div data-testid="courier-earnings-page">
      <TopBar subtitle="Meus ganhos" />
      <div className="px-4 pt-5">
        <h1 className="font-display text-2xl font-extrabold">Ganhos</h1>
        <div className="grid grid-cols-3 gap-2 mt-4">
          <Box testId="earnings-today" label="Hoje" value={brl(e.today)} accent />
          <Box testId="earnings-week" label="Semana" value={brl(e.week)} />
          <Box testId="earnings-month" label="Mês" value={brl(e.month)} />
        </div>
        <p className="text-xs text-gray-500 mt-3" data-testid="earnings-total-rides">
          {e.total_rides} corridas concluídas
        </p>

        <h2 className="font-display font-bold text-lg mt-7">Histórico de corridas</h2>
        <div className="grid gap-2 mt-3" data-testid="rides-history">
          {e.history.map((h) => (
            <div key={h.id} className="rounded-2xl border border-gray-200 p-3.5 bg-white flex justify-between items-center">
              <div className="min-w-0">
                <p className="font-semibold text-sm truncate">{h.store_name}</p>
                <p className="text-[11px] text-gray-500 truncate">{h.address}</p>
                <p className="text-[10px] text-gray-400">{new Date(h.created_at).toLocaleDateString("pt-BR")}</p>
              </div>
              <p className="font-display font-extrabold text-mage-green shrink-0 ml-2">{brl(h.payout)}</p>
            </div>
          ))}
          {e.history.length === 0 && <p className="text-sm text-gray-500">Nenhuma corrida ainda.</p>}
        </div>
      </div>
    </div>
  );
}

const Box = ({ label, value, accent, testId }) => (
  <div data-testid={testId} className="rounded-2xl border p-3 bg-white" style={{ borderColor: accent ? "#FF7A1A" : "#E5E7EB" }}>
    <p className="text-[10px] text-gray-500">{label}</p>
    <p className="font-display text-base font-extrabold">{value}</p>
  </div>
);
